"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;

var _faFilter = require("@fortawesome/pro-solid-svg-icons/faFilter");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _context = require("antd/es/config-provider/context");

var _renderEmpty = _interopRequireDefault(require("antd/es/config-provider/renderEmpty"));

var _table = _interopRequireWildcard(require("antd/es/table"));

Object.keys(_table).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _table[key];
    }
  });
});

require("./index.css");

require("../dropdown/index.css");

require("../pagination/index.css");

require("../tooltip/index.css");

var _react = _interopRequireDefault(require("react"));

var _ExpandIcon = _interopRequireDefault(require("./ExpandIcon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var DEFAULT_CHILDREN_COLUMN_NAME = 'children';

var FilterIcon = function FilterIcon() {
  return _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faFilter.faFilter
  });
};

var Table = function Table(_a) {
  var columns = _a.columns,
      dataSource = _a.dataSource,
      expandable = _a.expandable,
      rest = __rest(_a, ["columns", "dataSource", "expandable"]);

  var tableProps = __assign({
    columns: columns && columns.map(function (col) {
      return __assign({
        filterIcon: col.filters ? _react.default.createElement(FilterIcon, null) : undefined
      }, col);
    }),
    dataSource: dataSource
  }, rest);

  var hasNestedChildren = dataSource && dataSource.some(function (record) {
    return record && record[DEFAULT_CHILDREN_COLUMN_NAME];
  });

  if (expandable || hasNestedChildren) {
    tableProps.expandable = __assign(__assign({}, expandable), {
      expandIcon: (0, _ExpandIcon.default)()
    });
  }

  return _react.default.createElement(_context.ConfigContext.Provider, {
    value: {
      getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
        if (customizePrefixCls) return customizePrefixCls;
        return suffixCls ? "particle-" + suffixCls : 'particle';
      },
      renderEmpty: _renderEmpty.default
    }
  }, _react.default.createElement(_table.default, __assign({}, tableProps)));
};

Table.Summary = _table.default.Summary;
Table.Column = _table.default.Column;
Table.ColumnGroup = _table.default.ColumnGroup;
var _default = Table;
exports.default = _default;